module.exports = __webpack_public_path__ + "img/HNYT087_16.9f69b63a.gif";